/**
 * @description Hook utilizado para manipular os exames de identificação criminal
 * @author Diego Sabino
 * @file useExameIdentificacaoCriminal.js
 * @license Copyright (c) 2023 SIGEP DIGETI ITEP/RN
 */

const { useFetch } = require('./useFetch')

export const useExameIdentificacaoCriminalService = () => {
  const fetch = useFetch()

  const listarExameIdentificacaoCriminalParaExaminadorAsync = async (id, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/exameIdentificacaoCriminal/detalhado/examinador/${id}/`)
      return response.data.exameIdentificacaoCriminal
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const confirmarDadosExameIdentificacaoCriminal = async (
    idExame,
    idPericiando,
    valores,
    setProcessando
  ) => {
    try {
      if (setProcessando) setProcessando(true)

      const dadosFinalizacao = {
        inqueritoPolicial: valores.inqueritoPolicial,
        numeroProtocolo: valores.numeroProtocolo,
        nome: valores.nome,
        alcunha: valores.alcunha,
        cpf: valores.cpf,
        rg: valores.rg,
        filiacoes: valores.filiacoes?.map((f) => f.nome) || null,
        sexo: valores.sexo,
        nacionalidade: valores.nacionalidade,
        naturalidade: valores.naturalidade,
        idPericiando,
      }
      await fetch.putOpen(`/exameIdentificacaoCriminal/confirmarDados/${idExame}`, dadosFinalizacao)
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  return {
    listarExameIdentificacaoCriminalParaExaminadorAsync,
    confirmarDadosExameIdentificacaoCriminal,
  }
}
